module.exports = __webpack_public_path__ + "4cc83f0ea2eaec61694aaecc67a0eebb.png";